import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import {
  AlumniApprovalPendingList,
  AlumniApproveReject,
  GetFeeMaster,
  IMG_BASE_URL,
  IMG_BASE_URL3,
  RegFormAppPendingList,
  RegFormApprovedList,
  RegFormApproveReject,
  StudentFeeConcession,
} from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'

const AlumniAppPendingList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [concessionChecked, setConcessionChecked] = useState(false)

  const [feeTypes, setFeeTypes] = useState([])
  const [selectedFeeId, setSelectedFeeId] = useState('')
  const [feeAmount, setFeeAmount] = useState(0)
  const [concessionAmount, setConcessionAmount] = useState('')
  const [concessionRemark, setConcessionRemark] = useState('')

  const [approveLoading, setApproveLoading] = useState(false)
  const [rejectLoading, setRejectLoading] = useState(false)
  const [rejectReason, setRejectReason] = useState('')
  const [rejectModalOpen, setRejectModalOpen] = useState(false)

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (concessionChecked) {
      fetchFeeTypes()
    }
  }, [concessionChecked])

  const fetchFeeTypes = async () => {
    try {
      const res = await axios.get(
        `${GetFeeMaster}/${storedBranchId}/${BoardingYear}`,
      )
      setFeeTypes(res.data)
    } catch (err) {
      toast.error('Failed to load fee types')
    }
  }

  useEffect(() => {
    fetchRegAppPendingList()
  }, [])

  const fetchRegAppPendingList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${AlumniApprovalPendingList}`)

      const formatted = res.data.map((item, index) => ({
        key: item.id,
        index: index + 1,
        full_name: `${item.f_name} ${item.m_name} ${item.l_name}`,
        email: item.email || '-',
        date_of_birth: item.date_of_birth || '-',
        mobile: item.mobile || '-',
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false)
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.mobile ?? '').toString().includes(search) ||
      (item.email ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'Mobile No.', dataIndex: 'mobile' },
    { title: 'Email Id', dataIndex: 'email' },
    { title: 'Birth Date', dataIndex: 'date_of_birth' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  const applyFeeConcession = async () => {
    const payload = {
      branch_id: Number(storedBranchId),
      fee_id: Number(selectedFeeId),
      reg_id: Number(selectedRecord.reg_id),
      concession_remark: concessionRemark,
      concession_amount: Number(concessionAmount),
      year: Number(BoardingYear),
      fee_concession_flag: 1,
    }

    return axios.post(StudentFeeConcession, payload)
  }

  const handleCancel = () => {
    setViewModalOpen(false)
    setConfirmChecked(false)
    setConcessionChecked(false)
    setConcessionAmount('')
    setConcessionRemark('')
    setSelectedFeeId(null)
    setFeeAmount(null)

    fetchRegAppPendingList()
  }

  // const handleApproval = async (type) => {
  //   if (!selectedRecord) return

  //   const today = new Date().toISOString().split('T')[0]
  //   const approvalValue = type === 'approve' ? 2 : 3

  //   const approvalBody = {
  //     reg_id: Number(selectedRecord.reg_id),
  //     admin_approval: approvalValue,
  //     ...(approvalValue === 2 && { approval_date: today }),
  //   }

  //   if (concessionChecked && (!selectedFeeId || !concessionAmount)) {
  //     toast.warning('Please fill all concession details')
  //     return
  //   }

  //   try {
  //     //  set loader based on button type
  //     type === 'approve' ? setApproveLoading(true) : setRejectLoading(true)

  //     //  1. First approve/reject registration
  //     const res = await axios.put(RegFormApproveReject, approvalBody)

  //     if (res.data == 'APPROVED') {
  //       //  2. If approved + concession checked → call concession API
  //       if (type === 'approve' && concessionChecked) {
  //         if (!selectedFeeId || !concessionAmount) {
  //           toast.warning('Please fill concession details')
  //           return
  //         }

  //         await applyFeeConcession()
  //       }

  //       toast.success('Application Approved Successfully')
  //       setViewModalOpen(false)
  //       setConfirmChecked(false)
  //       fetchRegAppPendingList()
  //       return
  //     }
  //     if (res.data == 'REJECTED') {
  //       toast.success('Approval rejected !')
  //       setViewModalOpen(false)
  //       setConfirmChecked(false)
  //       fetchRegAppPendingList()
  //       return
  //     } else if (res.data == 'NOTFOUND') {
  //       toast.warn('Approval data not found !')
  //     } else if (res.data == 'ERROR') {
  //       toast.error('Error occurred !')
  //       return
  //     } else if (res.data !== 'APPROVED') {
  //       toast.error('Approval failed !')
  //       return
  //     }

  //     //  Reset & refresh
  //     handleCancel()
  //   } catch (error) {
  //     toast.error('Something went wrong!')
  //   } finally {
  //     //  stop loader
  //     setApproveLoading(false)
  //     setRejectLoading(false)
  //   }
  // }

  // useEffect(() => {
  //   if (concessionChecked && feeTypes.length >= 2) {
  //     const secondFee = feeTypes[1]

  //     setSelectedFeeId(secondFee.fee_id)
  //     setFeeAmount(secondFee?.feeAmounts?.[0]?.fee_amount || 0)
  //   }
  // }, [concessionChecked, feeTypes])

  const handleApproval = async (type) => {
    if (!selectedRecord) return

    const today = new Date().toISOString().split('T')[0]

    // validation
    if (type === 'reject' && !rejectReason.trim()) {
      toast.warning('Please enter rejection reason')
      return
    }

    const approvalBody = {
      admin_approval: type === 'approve' ? 1 : 2,
      approval_date: today,
      reason: type === 'reject' ? rejectReason : '',
    }

    try {
      type === 'approve' ? setApproveLoading(true) : setRejectLoading(true)

      //  pass ID in params
      const res = await axios.put(
        `${AlumniApproveReject}/${selectedRecord.id}`,
        approvalBody,
      )

      if (res.data === 'APPROVED') {
        //  apply concession if checked
        if (concessionChecked) {
          await applyFeeConcession()
        }

        toast.success('Application Approved Successfully')
      } else if (res.data === 'REJECTED') {
        toast.success('Application Rejected Successfully')
      } else {
        toast.error('Something unexpected happened')
      }

      // reset
      setRejectModalOpen(false)
      setRejectReason('')
      handleCancel()
    } catch (error) {
      toast.error('Something went wrong!')
    } finally {
      setApproveLoading(false)
      setRejectLoading(false)
    }
  }

  useEffect(() => {
    if (concessionChecked && feeTypes.length > 0) {
      const hostelFee = feeTypes.find((fee) => fee.fee_name === 'Hostel Fee')

      if (hostelFee) {
        setSelectedFeeId(hostelFee.fee_id)

        const amount =
          hostelFee?.feeAmounts?.length > 0
            ? hostelFee.feeAmounts[0].fee_amount
            : 0

        setFeeAmount(amount)
      }
    }
  }, [concessionChecked, feeTypes])

  const handleFeeChange = (e) => {
    const feeId = Number(e.target.value)
    setSelectedFeeId(feeId)

    const selectedFee = feeTypes.find((f) => f.fee_id === feeId)

    const amount =
      selectedFee?.feeAmounts?.length > 0
        ? selectedFee.feeAmounts[0].fee_amount
        : 0

    setFeeAmount(amount)
  }

  const docs = data.documents || {}
  //================================================
  // const downloadFile = (fileUrl, fileName) => {
  //   const link = document.createElement('a')
  //   link.href = fileUrl
  //   link.download = fileName
  //   document.body.appendChild(link)
  //   link.click()
  //   document.body.removeChild(link)
  // }

  const downloadFile = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl)
      const blob = await response.blob()

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.download = fileName
      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Download failed', error)
    }
  }

  const renderDocument = (filePath, title) => {
    if (!filePath) return null

    const fileUrl = `${IMG_BASE_URL}${filePath}`
    const isPDF = filePath.toLowerCase().endsWith('.pdf')

    return (
      <div className="col-12 col-md-6 col-lg-4 mb-3 mt-3 text-center">
        <p className="fw-semibold mb-1">{title}</p>

        {isPDF ? (
          <iframe
            src={fileUrl}
            title={title}
            style={{
              width: '100%',
              height: '300px',
              border: '1px solid #ddd',
              borderRadius: '6px',
            }}
          />
        ) : (
          <img
            src={fileUrl}
            alt={title}
            className="img-fluid rounded border"
            style={{
              width: '100%',
              height: '300px',
              objectFit: 'contain',
            }}
          />
        )}

        <Button
          size="small"
          type="primary"
          style={{ marginTop: '8px' }}
          onClick={() => downloadFile(fileUrl, title)}
        >
          Download
        </Button>
      </div>
    )
  }

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    const excelData = filteredData.map((item) => {
      const student = { ...item.full_data }

      // Flatten nested objects
      student.admin = student.admin?.username || ''
      student.documents = JSON.stringify(student.documents || {})

      return student
    })

    const worksheet = XLSX.utils.json_to_sheet(excelData)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Alumni Approval Pending',
    )

    XLSX.writeFile(workbook, 'Alumni_Approval_Pending_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Alumni Approval Pending List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => {
          setViewModalOpen(false)
          handleCancel()
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Alumni Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* ========= PERSONAL INFORMATION ========== */}
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12 col-md-3">
                    <img
                      src={`${IMG_BASE_URL3}${selectedRecord.profile_img}`}
                      alt="Picture"
                      className="rounded-circle text-center img-fluid rounded border"
                      style={{
                        width: '160px',
                        height: '160px',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-9">
                    <div className="row">
                      <div className="col-md-12 py-1">
                        <span style={labelCss}>Full Name:</span>
                        <br />
                        <span
                          style={{
                            backgroundColor: '#f8ff90',
                            padding: '2px 10px',
                            fontSize: '16px',
                          }}
                        >
                          {selectedRecord.f_name} {selectedRecord.m_name}{' '}
                          {selectedRecord.l_name}
                        </span>
                      </div>

                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Qualification:</span>
                        <br /> {selectedRecord.qualification || '-'}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Professional Category:</span>
                        <br /> {selectedRecord.jobCategoryData.category_name}
                      </div>
                      <div className="col-md-8 py-1">
                        <span style={labelCss}>Current Address:</span>
                        <br /> {selectedRecord.current_address}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Pincode:</span>
                        <br /> {selectedRecord.pincode}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>State:</span>
                        <br /> {selectedRecord.stateData.stateenname}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>District:</span>
                        <br /> {selectedRecord.districtData.districtenname}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Taluka:</span>
                        <br /> {selectedRecord.talukaData.talukaenname}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Date of Birth:</span>
                        <br /> {selectedRecord.date_of_birth}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Blood Group:</span>
                        <br /> {selectedRecord.blood_group}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Mobile No:</span>
                        <br /> {selectedRecord.mobile}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Email Id:</span>
                        <br /> {selectedRecord.email}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Business / Service Name:</span>
                        <br /> {selectedRecord.business_service_name}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Year Of Boarding From:</span>
                        <br /> {selectedRecord.from_year_of_boarding}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Year Of Boarding To:</span>
                        <br /> {selectedRecord.to_year_of_boarding}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Reference Name:</span>
                        <br /> {selectedRecord.reference_fname}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Reference Contact:</span>
                        <br /> {selectedRecord.reference_other_contact_details}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Achievements:</span>
                        <br /> {selectedRecord.achievements}
                      </div>
                      <div className="col-md-6 py-1">
                        <span style={labelCss}>Suggestion:</span>
                        <br /> {selectedRecord.suggestion_comment}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/**-----------APPROVE/REJECT SECTION-----------------*/}

            <div className="mt-4 p-3">
              {/* Confirm Checkbox */}
              <div className="d-flex align-items-center mb-3">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  style={{ border: '1px solid black' }}
                  checked={confirmChecked}
                  onChange={(e) => setConfirmChecked(e.target.checked)}
                />
                <label style={{ fontSize: '15px', fontWeight: '500' }}>
                  I confirm all details are checked and verified
                </label>
              </div>

              {/* Buttons */}
              <div className="d-flex gap-3 mt-3">
                <Button
                  type="primary"
                  disabled={!confirmChecked}
                  loading={approveLoading}
                  onClick={() => handleApproval('approve')}
                >
                  Approve
                </Button>

                <Button
                  danger
                  disabled={!confirmChecked}
                  loading={rejectLoading}
                  onClick={() => setRejectModalOpen(true)}
                >
                  Reject
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      <Modal
        title="Reject Reason"
        open={rejectModalOpen}
        onCancel={() => setRejectModalOpen(false)}
        onOk={() => handleApproval('reject')}
        okText="Submit"
        confirmLoading={rejectLoading}
      >
        <Input.TextArea
          rows={4}
          placeholder="Enter rejection reason"
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
        />
      </Modal>
    </div>
  )
}

export default AlumniAppPendingList
